<template>
  <v-container class="white-wrapper" fluid>
    <div class="config-title" style="max-width: 25rem; margin: 0 auto">
      <router-link to="/config/news/lists" class="back-icon">
        <v-btn icon large>  
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </v-btn>
      </router-link>
      <div class="text-h6 font-weight-bold">{{$t('Notice.title')}}</div>
    </div>
    <div class="panels-container">
      <template > <!-- v-if="list.length === 0" -->
        <div class="item-wrapper justify-center">

          <div class="notice">
            <div class="notice-list">
              <div class="notice-info">
                <div class="notice-category">[ <span>{{list.title_sub}}</span> ]</div>
                <div class="notice-title">{{list.title}}</div>  
                <div class="notice-list_newimg"></div>
              </div>
              <div class="notice-date">{{$moment(list.created_at).format('YYYY.MM.DD')}}</div>
              <!-- $moment(item.up_created_at).format('YYYY-MM-DD HH:mm:ss') -->
            </div>
  
            <div class="notice-content" v-html="list.content_img"> </div>
          </div>

          <button type="button" class="notice-list_btn">
            <router-link to="/config/news/lists">{{$t('Notice.lists')}}</router-link>
          </button>
          
        </div>
      </template>
 
    </div>
  </v-container>
</template>

<script>
import $ from 'jquery' ; 
export default {
  props: {
    // news: {
    //   type: Object
    // },
    id: String
  },
  data() {
    return {
      list: [],
      tmp:[],
      noMore: false,
      page: 1,
      size: 5
    }
  },
  computed: {
    isLoading() { 
      return this.$store.getters.loading
    }
  },
  created() {
    console.log(this.id)
    this.$store.commit('loading', true) ;
    this.$store.dispatch('w_l_contents',{
        page: this.page,
        size: this.size
      }).then((res) => {
      const tmp = res.filter((item) => item.cid.toString() === this.id)[0]
      console.log( tmp )
      if (tmp) this.list = tmp
      else this.$router.push('/')
    });
    // console.log( this.news  )

    // this.$el.querySelector("span").style.backgroundColor ='black' 

    this.$store.commit('loading', false) ;
    //console.log("refs :: " , document.querySelectorAll("div.notice-content img"));
  // document.querySelector("div.notice-content img").style.width = "100%";


    // this.$store.commit('loading', true)
    // this.callAPI()
  },
  methods: {
    callAPI() {
      const params = {
        page: this.page,
        size: this.size
      }
      this.$store.commit('loading', true)
      this.$store
        .dispatch('my_point_history', params)
        .then((res) => {
          this.$store.commit('loading', false)
          if (res.status === 200 && res.data.result[0].length > 0) {
            const arr = res.data.result[0]
            this.list = this.list.concat(arr)



 
    //         $("div.notice-content p img").style = "width:100%!important;" ; //({'width':'100px'});
    //         $("img").addClass('fullImg')

    // console.log("ssss: " , $("img").length, $("div.notice-content p img") )

    
    // const fruitEls = document.querySelectorAll("div.notice-content img");
    // fruitEls.forEach((el) => {
    //   console.log("el::"  , el) 
    //   el.style.border = "1px solid blue";
    //   el.style.padding = "24px";
    //   el.width = "48px";
    //  // el.classList.add("active");
     
    // });


            if (arr.length < this.size) this.noMore = true
          } else if (res.data.result[0].length === 0) {
            this.noMore = true
          } else throw res
        })
        .catch((err) => {
          this.$store.commit('loading', false)
          this.$store.dispatch('toast', {
            toast: true,
            toast_msg: this.$t('errorServer'),
            timeout: 2000
          })
          // console.log(err)
        })
    },
    getMore() {
      this.page = this.page + 1
      this.callAPI()
    }
  }
}
</script>

<style scoped>
/* .panels-container {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
} */
.item-wrapper {
  margin: 0.5rem 0;
}
.date-wrapper {
  font-size: 0.8rem;
  color: #cbcbcb;
  font-weight: 500;
}
.type-wrapper {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}
.content-wrapper {
  font-size: 0.9rem;
  display: flex;
  justify-content: flex-end;
}
.unpaid-text {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.notice {
  border-top: 1px solid #9F9F9F;
  border-bottom: 1px solid #9F9F9F;
}
.notice-list {
  width: 100%;
  height: auto;
  padding: 15px;
  border-bottom: 1px solid #D0D0D0;
  word-break:break-all;
}
.notice-list_important {
  background-color: #7A94AD33;
}
.notice-info {
  width: 100%;
}
.notice-info > div {
  font-size: 1.1rem;
}
.notice-category {
  color: #013E79;
  font-weight: bold;
  float: left;
}
.notice-title {
  display: inline;
  margin: 0 5px;
}
.notice-list_newimg {
  display: inline-block;
  width: 17px;
  height: 17px;
  /* background: url(`require(@/assets/icon/new.svg)`) 100% 100% / cover; */
}
.notice-date {
  font-size: 0.9rem;
  color: #9A9A9A;
  margin-top: 5px;
}
.notice-content {
  height: auto;
  font-size: 1.1rem;
  margin: 30px 0 50px;
  padding-left: 20px;
}

.notice-content > img {
  width:100% !important;
}
.fw-100 {
  width:100% !important;
} 



.notice-list_btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #9F9F9F;
  border-radius: 9px;
  margin: 20px auto 60px;
  cursor: pointer;
}
</style>
